import type { FeatureFlag } from '@ps/web-core-enums';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { select } from '../..';
import type { RootState } from '../types';

export const useFeature = (flag: FeatureFlag) => {
  const selector = useCallback((state: RootState) => select.feature.check(state, flag), [flag]);
  return useSelector(selector);
};
